import React from 'react';
import { ArrowUp, ArrowDown, Trash2 } from 'lucide-react';
import '../styles/SurveyForm.css';
import '../styles/common.css';
import LimitedTextarea from './LimitedTextarea';

export default function ChallengeQuestionEditor({ question, index, onUpdate, onDelete, onMove }) {
  const ICON_SIZE = 16;

  const handleTextChange = (e) => {
    onUpdate(index, { ...question, text: e.target.value });
  };

  const handleExpectedAnswerChange = (e) => {
    onUpdate(index, { ...question, expectedAnswer: e.target.value });
  };

  return (
    <div className="question-editor">
      <label className="field-label" htmlFor={`challenge-text-${index}`}>
        Challenge Question
      </label>
      <LimitedTextarea
        id={`challenge-text-${index}`}
        className="survey-textarea"
        rows={2}
        placeholder="Enter the challenge question…"
        value={question.text || ''}
        onChange={handleTextChange}
      />

      <label className="field-label" htmlFor={`challenge-expected-${index}`} style={{ marginTop: 12 }}>
        Expected Answer
      </label>
      <LimitedTextarea
        id={`challenge-expected-${index}`}
        className="survey-textarea"
        rows={2}
        placeholder="Prefer a single lowercase word so the system can verify an exact match"
        value={question.expectedAnswer || ''}
        onChange={handleExpectedAnswerChange}
      />

      <div className="question-actions" style={{ display: 'flex', gap: 6, marginTop: 8, flexWrap: 'wrap' }}>
        <button
          type="button"
          className="post-button icon-button"
          aria-label="Move challenge question up"
          title="Move up"
          onClick={() => onMove(index, 'up')}
        >
          <ArrowUp size={ICON_SIZE} />
        </button>
        <button
          type="button"
          className="post-button icon-button"
          aria-label="Move challenge question down"
          title="Move down"
          onClick={() => onMove(index, 'down')}
        >
          <ArrowDown size={ICON_SIZE} />
        </button>
        <button
          type="button"
          className="post-button icon-button danger"
          aria-label="Delete challenge question"
          title="Delete challenge question"
          onClick={() => onDelete(index)}
        >
          <Trash2 size={ICON_SIZE} />
        </button>
      </div>
    </div>
  );
}
